import type { ScaleChoice } from './views2dTypes'

// Formatação partilhada pelo modo 2D. Vive num ficheiro `.ts` (e não
// junto aos componentes) porque o `react-refresh` só faz hot reload
// correcto de ficheiros que exportem exclusivamente componentes.

export function scaleLabel(s: ScaleChoice): string {
  return s === 'fit' ? 'Ajustar à folha' : `1:${s}`
}

export function fmtNum(v: number, decimals = 2): string {
  if (!Number.isFinite(v)) return '-'
  const t = v.toFixed(decimals)
  // -9e-11 arredonda a "-0.00": o sinal de um zero não diz nada a ninguém.
  return Number(t) === 0 ? t.replace('-', '') : t
}
